/* Beach Camera homepage sections — shared behaviors.
   Safe to load multiple times (per-element init guards).
   Re-inits on Shopify theme-editor section reloads. */
(function () {
  if (window.__bcxHomeLoaded) { window.__bcxHomeInitAll && window.__bcxHomeInitAll(); return; }
  window.__bcxHomeLoaded = true;

  document.body.classList.add('bcx-page');
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = matchMedia('(hover:hover) and (pointer:fine)').matches;

  function initBcx(sec) {
    if (!sec || sec.__bcxInit) return;
    sec.__bcxInit = true;
    if (!reduce) sec.classList.add('anim');
    var qs = function (s) { return sec.querySelector(s); };

    /* reveal on scroll */
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: 0.14 });
    sec.querySelectorAll('.rv,.rv2,.mask').forEach(function (el) { io.observe(el); });
    requestAnimationFrame(function () {
      sec.querySelectorAll('.feature .rv,.feature .rv2').forEach(function (el) { el.classList.add('in'); });
    });
    setTimeout(function () {
      sec.querySelectorAll('.rv,.rv2,.mask').forEach(function (el) { el.classList.add('in'); });
    }, 1400);

    /* belt label relocation — place above the previous section when flagged */
    (function () {
      var belt = sec.querySelector('[data-bcx-belt-up]');
      if (!belt) return;
      document.querySelectorAll('[data-bcx-belt-slot]').forEach(function (old) { old.remove(); });
      var host = sec.closest('.shopify-section');
      var prev = host && host.previousElementSibling;
      if (!prev) return;
      var w = document.createElement('div');
      w.className = 'bcx';
      w.setAttribute('data-bcx-belt-slot', '');
      w.appendChild(belt);
      prev.parentNode.insertBefore(w, prev);
    })();

    /* mobile: swipe-row position dots */
    (function () {
      if (!matchMedia('(max-width:600px)').matches) return;
      ['.bento', '.shelf', '.cats'].forEach(function (selr) {
        var row = sec.querySelector(selr);
        if (!row || row.__dots) return;
        if (row.scrollWidth <= row.clientWidth + 10) return;
        var kids = [].slice.call(row.children);
        if (kids.length < 2) return;
        row.__dots = 1;
        var wrap = document.createElement('div');
        wrap.className = 'bcx-swipedots';
        kids.forEach(function (k, i) {
          var b = document.createElement('button');
          b.setAttribute('aria-label', 'Go to item ' + (i + 1));
          if (i === 0) b.className = 'on';
          b.addEventListener('click', function () {
            row.scrollTo({ left: Math.max(0, k.offsetLeft - row.offsetLeft - (row.clientWidth - k.clientWidth) / 2), behavior: 'smooth' });
          });
          wrap.appendChild(b);
        });
        row.parentNode.insertBefore(wrap, row.nextSibling);
        var dots = [].slice.call(wrap.children), rf = null;
        row.addEventListener('scroll', function () {
          if (rf) return;
          rf = requestAnimationFrame(function () {
            rf = null;
            var x = row.scrollLeft + row.clientWidth / 2, bi = 0;
            kids.forEach(function (k, i) { if (k.offsetLeft - row.offsetLeft <= x) bi = i; });
            dots.forEach(function (d, i) { d.classList.toggle('on', i === bi); });
          });
        }, { passive: true });
      });
    })();

    /* proof strip: scroll to reviews section */
    (function () {
      var link = sec.querySelector('[data-bcx-proof-anchor]');
      if (!link || link.__bound) return;
      link.__bound = 1;
      link.addEventListener('click', function () {
        var frag = link.getAttribute('data-bcx-proof-anchor') || '';
        var target = frag && document.querySelector('.shopify-section[id*="' + frag + '"]');
        if (target) target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      });
    })();

    /* best sellers: brand filter chips */
    (function () {
      var chips = qs('[data-bcx-brandchips]');
      if (!chips || chips.__built) return;
      var shelf = sec.querySelector('.shelf');
      if (!shelf) return;
      var cards = [].slice.call(shelf.querySelectorAll('.pcard'));
      var brands = [];
      cards.forEach(function (c) {
        var b = (c.getAttribute('data-brand') || '').trim();
        if (b && brands.indexOf(b) < 0) brands.push(b);
      });
      if (brands.length < 2) { chips.style.display = 'none'; return; }
      chips.__built = 1;
      function makeChip(label) {
        var b = document.createElement('button');
        b.type = 'button';
        b.textContent = label;
        b.addEventListener('click', function () {
          [].slice.call(chips.children).forEach(function (x) { x.classList.remove('on'); });
          b.classList.add('on');
          cards.forEach(function (c) {
            var show = label === 'All' || (c.getAttribute('data-brand') || '').trim() === label;
            c.classList.toggle('bcx-hide', !show);
          });
          shelf.scrollTo({ left: 0, behavior: 'smooth' });
        });
        return b;
      }
      var all = makeChip('All');
      all.classList.add('on');
      all.setAttribute('aria-pressed', 'true');
      chips.appendChild(all);
      brands.forEach(function (b) { chips.appendChild(makeChip(b)); });
      chips.addEventListener('click', function () {
        [].slice.call(chips.children).forEach(function (x) { x.setAttribute('aria-pressed', x.classList.contains('on') ? 'true' : 'false'); });
      });
      /* free-shipping assurance chips */
      cards.forEach(function (c) {
        if (c.querySelector('.bcx-ship')) return;
        var pr = c.querySelector('.pr');
        if (!pr) return;
        var s = document.createElement('div');
        s.className = 'bcx-ship';
        s.textContent = '✓ Free shipping';
        pr.parentNode.insertBefore(s, pr.nextSibling);
      });
    })();

    /* stat counter-up on first view */
    (function () {
      var nums = sec.querySelectorAll('.lstats .n');
      if (!nums.length || reduce) return;
      var io2 = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (!e.isIntersecting) return;
          io2.unobserve(e.target);
          var el = e.target, m = (el.textContent || '').trim().match(/^(\d+)(.*)$/);
          if (!m) return;
          var target = parseInt(m[1], 10), suf = m[2], t0 = null;
          function step(ts) {
            if (!t0) t0 = ts;
            var p = Math.min(1, (ts - t0) / 900);
            p = 1 - Math.pow(1 - p, 3);
            el.textContent = Math.round(target * p) + suf;
            if (p < 1) requestAnimationFrame(step);
          }
          requestAnimationFrame(step);
        });
      }, { threshold: 0.5 });
      nums.forEach(function (n) { io2.observe(n); });
    })();

    /* desktop: cursor-tracked tilt + sheen on cards */
    if (fine && !reduce) {
      sec.querySelectorAll('.bx, .pcard, .cat').forEach(function (card) {
        card.addEventListener('pointermove', function (e) {
          var r = card.getBoundingClientRect();
          var px = (e.clientX - r.left) / r.width, py = (e.clientY - r.top) / r.height;
          card.style.setProperty('--mx', (px * 100) + '%');
          card.style.setProperty('--my', (py * 100) + '%');
          if (card.classList.contains('bx')) {
            card.style.setProperty('--rx', ((py - 0.5) * -3) + 'deg');
            card.style.setProperty('--ry', ((px - 0.5) * 4.5) + 'deg');
          }
        });
        card.addEventListener('pointerleave', function () {
          card.style.setProperty('--rx', '0deg');
          card.style.setProperty('--ry', '0deg');
        });
      });
    }

    /* story carousel */
    (function () {
      var track = qs('[data-bcx-track]'); if (!track) return;
      var slides = [].slice.call(track.children), n = slides.length;
      var dotsWrap = qs('[data-bcx-sdots]'), count = qs('.story-count');
      if (!n || !dotsWrap) return;
      var idx = 0, timer = null;
      function p2(x) { return (x < 9 ? '0' : '') + (x + 1); }
      slides.forEach(function (_, i) {
        var b = document.createElement('button');
        b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        if (i === 0) b.className = 'on';
        b.addEventListener('click', function () { go(i); rest(); });
        dotsWrap.appendChild(b);
      });
      var dots = [].slice.call(dotsWrap.children);
      function go(i) {
        idx = (i + n) % n;
        track.style.transform = 'translateX(-' + (idx * 100) + '%)';
        dots.forEach(function (d, j) { d.classList.toggle('on', j === idx); });
        slides.forEach(function (s, j) { s.classList.toggle('active', j === idx); });
        if (count) count.textContent = p2(idx) + ' / ' + p2(n - 1);
        var act = slides[idx];
        if (act && !reduce) {
          act.querySelectorAll('.rv,.rv2').forEach(function (el) { el.classList.remove('in'); void el.offsetWidth; });
          setTimeout(function () {
            act.querySelectorAll('.rv,.rv2').forEach(function (el) { el.classList.add('in'); });
          }, 80);
        }
      }
      function auto() { if (reduce) return; timer = setInterval(function () { go(idx + 1); }, 6500); }
      function rest() { clearInterval(timer); auto(); }
      var nx = qs('[data-bcx-snext]'), pv = qs('[data-bcx-sprev]');
      if (nx) nx.addEventListener('click', function () { go(idx + 1); rest(); });
      if (pv) pv.addEventListener('click', function () { go(idx - 1); rest(); });
      var wrap = track.closest('.story-wrap');
      if (wrap) { wrap.addEventListener('mouseenter', function () { clearInterval(timer); }); wrap.addEventListener('mouseleave', rest); }
      var x0 = null;
      track.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      track.addEventListener('touchend', function (e) {
        if (x0 == null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) { go(idx + (dx < 0 ? 1 : -1)); rest(); }
        x0 = null;
      }, { passive: true });
      go(0); auto();
    })();

    /* infinite brand belt */
    (function () {
      var t = qs('[data-bcx-marq]'); if (!t) return;
      var unit = t.firstElementChild; if (!unit) return;
      function fill() {
        var need = (t.parentElement ? t.parentElement.clientWidth : window.innerWidth) * 2 + 400, g = 0;
        while (t.scrollWidth < need && g < 80) { t.appendChild(unit.cloneNode(true)); g++; }
        if (t.children.length % 2) t.appendChild(unit.cloneNode(true));
        t.style.animationDuration = Math.max(70, Math.round((t.scrollWidth / 2) / 26)) + 's';
      }
      fill();
      var rt;
      addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(fill, 200); }, { passive: true });
    })();

    /* floating "next section" arrow — scrolls to the next theme section */
    (function () {
      var fab = qs('[data-bcx-downfab]'); if (!fab) return;
      function nextSection() {
        var host = sec.closest('.shopify-section') || sec;
        var n = host.nextElementSibling;
        while (n && n.offsetHeight === 0) n = n.nextElementSibling;
        return n;
      }
      fab.addEventListener('click', function () {
        var n = nextSection();
        if (n) n.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth' });
      });
      function upd() {
        var story = document.querySelector('.bcx .story');
        if (story) {
          var sr = story.getBoundingClientRect();
          fab.classList.toggle('ondark', sr.top < innerHeight * 0.5 && sr.bottom > innerHeight * 0.5);
        }
        var doc = document.documentElement;
        fab.classList.toggle('hide', doc.scrollTop + innerHeight >= doc.scrollHeight - 200);
      }
      addEventListener('scroll', upd, { passive: true }); upd();
    })();

    /* rotating promo banners */
    (function () {
      var track = qs('[data-bcx-bnr-track]'); if (!track) return;
      var slides = [].slice.call(track.children), n = slides.length;
      var dotsWrap = qs('[data-bcx-bnr-dots]');
      if (!n || !dotsWrap) return;
      var idx = 0, timer = null, userPaused = false;
      slides.forEach(function (_, i) {
        var b = document.createElement('button');
        if (i === 0) b.className = 'on';
        b.setAttribute('aria-label', 'Banner ' + (i + 1));
        b.addEventListener('click', function () { go(i); rest(); });
        dotsWrap.appendChild(b);
      });
      var dots = [].slice.call(dotsWrap.children);
      function go(i) {
        idx = (i + n) % n;
        track.style.transform = 'translateX(-' + (idx * 100) + '%)';
        dots.forEach(function (d, j) { d.classList.toggle('on', j === idx); });
      }
      function auto() { if (reduce) return; timer = setInterval(function () { go(idx + 1); }, 5500); }
      function rest() { clearInterval(timer); if (!userPaused) auto(); }
      var nx = qs('[data-bcx-bnr-next]'), pv = qs('[data-bcx-bnr-prev]');
      if (nx) nx.addEventListener('click', function (e) { e.preventDefault(); go(idx + 1); rest(); });
      if (pv) pv.addEventListener('click', function (e) { e.preventDefault(); go(idx - 1); rest(); });
      var box = qs('[data-bcx-bnr]');
      if (box) { box.addEventListener('mouseenter', function () { clearInterval(timer); }); box.addEventListener('mouseleave', rest); }
      var pBtn = qs('[data-bcx-bnr-pause]');
      var PS = '<svg width="11" height="11" viewBox="0 0 24 24" fill="currentColor"><rect x="6" y="5" width="4" height="14"/><rect x="14" y="5" width="4" height="14"/></svg>';
      var PL = '<svg width="11" height="11" viewBox="0 0 24 24" fill="currentColor"><path d="M7 5l12 7-12 7z"/></svg>';
      if (pBtn) {
        pBtn.innerHTML = PS;
        pBtn.addEventListener('click', function () {
          userPaused = !userPaused;
          sec.classList.toggle('paused', userPaused);
          if (userPaused) { clearInterval(timer); pBtn.innerHTML = PL; pBtn.setAttribute('aria-label', 'Play banner rotation'); }
          else { auto(); pBtn.innerHTML = PS; pBtn.setAttribute('aria-label', 'Pause banner rotation'); }
        });
      }
      var x0 = null;
      track.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      track.addEventListener('touchend', function (e) {
        if (x0 == null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) { go(idx + (dx < 0 ? 1 : -1)); rest(); }
        x0 = null;
      }, { passive: true });
      go(0); auto();
      var img0 = track.querySelector('img');
      function ready() { if (box) box.classList.add('bnr-ready'); }
      if (img0) { if (img0.complete && img0.naturalWidth) ready(); else img0.addEventListener('load', ready); }
    })();
  }

  /* signature: page scroll progress hairline */
  (function () {
    if (document.querySelector('.bcx-progress')) return;
    var pb = document.createElement('div');
    pb.className = 'bcx-progress';
    document.body.appendChild(pb);
    function pup() {
      var d = document.documentElement;
      var max = d.scrollHeight - innerHeight;
      pb.style.transform = 'scaleX(' + (max > 0 ? Math.min(1, Math.max(0, d.scrollTop / max)) : 0) + ')';
    }
    addEventListener('scroll', pup, { passive: true });
    addEventListener('resize', pup, { passive: true });
    pup();
  })();

  /* floating section dock — desktop */
  (function () {
    if (document.querySelector('.bcx-dock')) return;
    if (!matchMedia('(min-width:1024px) and (pointer:fine)').matches) return;
    function build() {
      var items = [
        ['[data-bcx="banner"]', 'Deals'],
        ['[data-bcx="bestsellers"]', 'Best sellers'],
        ['[data-bcx="categories"]', 'Categories'],
        ['[data-bcx="story"]', 'Our story'],
        ['.shopify-section[id*="1741110348"]', 'Reviews']
      ].map(function (p) {
        var el = document.querySelector(p[0]);
        return el ? { el: el.closest('.shopify-section') || el, label: p[1] } : null;
      }).filter(Boolean);
      if (items.length < 3) return;
      var dock = document.createElement('nav');
      dock.className = 'bcx-dock';
      dock.setAttribute('aria-label', 'Jump to section');
      items.forEach(function (it) {
        var b = document.createElement('button');
        b.type = 'button';
        b.textContent = it.label;
        b.addEventListener('click', function () {
          it.el.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        });
        it.btn = b;
        dock.appendChild(b);
      });
      document.body.appendChild(dock);
      function upd() {
        dock.classList.toggle('show', scrollY > 700);
        var y = innerHeight * 0.4, act = null;
        items.forEach(function (it) { if (it.el.getBoundingClientRect().top <= y) act = it; });
        items.forEach(function (it) { it.btn.classList.toggle('on', it === act); });
      }
      addEventListener('scroll', upd, { passive: true });
      upd();
    }
    if (document.readyState !== 'loading') build();
    else document.addEventListener('DOMContentLoaded', build);
  })();

  function initAll() { document.querySelectorAll('.bcx[data-bcx]').forEach(initBcx); }
  window.__bcxHomeInitAll = initAll;

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target && e.target.querySelector && e.target.querySelector('.bcx[data-bcx]');
    if (el) initBcx(el);
  });
})();
